import React, { Suspense } from 'react';
import { BrowserRouter as Router, Navigate, Routes, Route } from 'react-router-dom';
import ScrollToTop from './components/ScrollToTop';

// Public Pages
import LandingPage from './pages/LandingPage';
import AboutPage from './pages/AboutPage';
import ServicesPage from './pages/ServicesPage';
import Events from './pages/Event'
import ContactPage from './pages/ContactPage';
import GalleryPage from './pages/GalleryPage';
import FaqPage from './pages/FaqPage';
import PrivacyPolicyPage from './pages/PrivacyPolicyPage';
import TermsOfServicePage from './pages/TermsOfServicePage';
import VaccinationPolicyPage from './pages/VaccinationPolicyPage';
import CancellationPolicyPage from './pages/CancellationPolicyPage';

import './index.css';
import WhatsAppFloat from './components/WhatsAppFloat';

function AppWrapper() {
  return (
        <div className="App page-load pt-16">
          <Suspense fallback={<div /> }>
          <Routes>
            {/* Public Routes */}
            <Route path="/" element={<LandingPage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/services" element={<ServicesPage />} />
            <Route path="/events" element={<Events/>}/>
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/gallery" element={<GalleryPage />} />
            <Route path="/faq" element={<FaqPage />} />
            <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
            <Route path="/terms-of-service" element={<TermsOfServicePage />} />
            <Route path="/vaccination-policy" element={<VaccinationPolicyPage />} />
            <Route path="/cancellation-policy" element={<CancellationPolicyPage />} />
            <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
            </Suspense>
            <WhatsAppFloat />
          </div>
  );
}

function App() {
  return (
    <Router>
      <ScrollToTop>
        <AppWrapper />
      </ScrollToTop>
        
    </Router>
  );
}

export default App;
